import {useState} from 'react'

interface UseSubmitReturn<T extends unknown[]> {
    handleSubmit: (...args: T) => Promise<void>
    loading: boolean
    error: Error | null
    clearError: () => void
}

const useSubmit = <T extends unknown[]>(
    submitFunction: (...args: T) => Promise<void>,
): UseSubmitReturn<T> => {
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<Error | null>(null)

    const handleSubmit = async (...args: T) => {
        try {
            setLoading(true)
            setError(null)

            await submitFunction(...args)
        } catch (error) {
            setError(error as Error)
        } finally {
            setLoading(false)
        }
    }

    const clearError = () => {
        setError(null)
    }

    return {handleSubmit, loading, error, clearError}
}

export default useSubmit
